<template>
  <b-container>
    <b-row>
      <b-col cols="12" md="8">
        <h4 class="text-center">Kết quả luyện tập gần nhất</h4>

        <div class="chart">
          <class-chart :chart-data="datacollection"></class-chart>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <h4 class="text-center">Tiện ích</h4>

        <div>
          <b-link
            block
            variant="light"
            size="sm"
            class="btn btn-block btn-light mb-3"
            :to="{ name: 'class-list' }"
          >
            <img src="@/assets/images/ic_sai.png" alt="" height="30" />
            <span>Luyện tập thêm</span>
          </b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ClassChart from "./ClassChart.js";

import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { APP_CONFIG } from "@/utils/constants";
// import moment from "moment";

export default {
  name: "ClassStatistic",
  components: {
    ClassChart
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      datacollection: null
    };
  },
  metaInfo() {
    return {
      title: "Kết quả ôn tập"
    };
  },
  computed: {
    ...mapGetters({
      statistics: `${STORE_KEY}/statistics`
    })
  },
  mounted() {
    this.getClassStatistic();
    // this.fillData()
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["getClassStatistic"]),
    fillData() {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          },
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  },
  watch: {
    statistics: function() {
      // this.datacollection = {
      //   labels: this.statistics.reduce((res, item) => {
      //     res.push(item);
      //   }, []),
      //   datasets: [

      //   ]
      // }
      let dataLabels = [];
      let dataList = {
        reading: [],
        listening: [],
        writing: []
      };
      for (var index in this.statistics) {
        dataLabels.push(index);

        dataList.reading.push(this.statistics[index].reading.correct);
        dataList.listening.push(this.statistics[index].listening.correct);
        dataList.writing.push(this.statistics[index].writing.correct);
      }
      this.datacollection = {
        labels: dataLabels,
        datasets: [
          {
            label: "Nghe",
            backgroundColor: "rgba(255,50,35,1.0)",
            barThickness: 15,
            data: dataList.listening
          },
          {
            label: "Đọc",
            backgroundColor: "rgba(236,111,45,1.0)",
            barThickness: 15,
            data: dataList.reading
          },
          {
            label: "Viết",
            backgroundColor: "rgba(239,158,57,1.0)",
            barThickness: 15,
            data: dataList.writing
          }
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Thống kê kết quả luyện tập theo ngày"
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      };
    }
  }
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
.chart {
  /* max-height: 480px; */
}
</style>
